import { render, staticRenderFns } from "./CompositionSummary.vue?vue&type=template&id=677eec80&"
import script from "./CompositionSummary.vue?vue&type=script&lang=ts&"
export * from "./CompositionSummary.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports